import React from "react";
import { Button } from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

interface Props {
    onClick: () => void;
}

// Brush ズームを全グラフ既定（全範囲）へ戻すボタン。
// 表示範囲のリセットのみで、データ・API リクエスト・取得タイミングは変えない。
export const ChartZoomResetButton: React.FC<Props> = ({ onClick }) => (
    <Button
        size="small"
        variant="outlined"
        startIcon={<RestartAltIcon />}
        onClick={onClick}
        aria-label="ズームをリセット"
    >
        ズームをリセット
    </Button>
);
